import {Image, Text, TouchableOpacity} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import strings from '../../../translations';
import styleSheet from './styles';

export interface ViewAnalyticsButtonForWebProps {
  onPress(): void;
}

const ViewAnalyticsButtonForWeb = (props: ViewAnalyticsButtonForWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={styles.buttonStyle}
      onPress={props.onPress}>
      <Image
        source={theme.images.chartsTabActive}
        style={styles.imageStyle}
        resizeMode="contain"
      />

      <Text style={styles.buttonLabelStyle}>
        {strings.analyticsScreen.view}
      </Text>
    </TouchableOpacity>
  );
};

export default ViewAnalyticsButtonForWeb;
